// extracted by mini-css-extract-plugin
export default {"root":"root___RJKHA","content":"content___iEBk3"};